module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAYAAACeXl35AAABT0lEQVRIS7XVMUvDQBQH8P9LbNVRFERoipZO6heQZlD7IVzUwUGsnfwG/RShgyKdHVyck4LQxc2hDtIh1KGImwhS6T0JktDUXC9N0pvv3o/j3v8dYY6rct4r5vL50vtaodNt0NCjaF5etdY/FhDXABYJeBp8fJrdu93hXMDDC/eEiW4B1v0LEXHFtjY7mYNRGIi+GKNy29oaZApGYQz+0Vg/spvGfaZvGAfLDIyLZQLOgoXAg7q7A9ZOCfxiW0YLIFZFZlYsAKv1t1UhRq8AVv4QajnrxhkaJGRoEiwA9y9dkxiP4eJyNCkWgHtX/eWlb/EMoKxC02ChNzRrbinH7ICoKEPTYv+6dBrK0ByCuBkfV5OhVjVZZCzkaLhcEkyaQxWaFJsafBmaBlNOmkk0LaYEvQ0+yoSN8akfp0Gi9sT6njx0gfXtdrPwkBTyz/0CQFX4Fe2nXn0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rectangle.png
// module id = qN4d
// module chunks = 1